<div class="inner-container">
  <div class="ql-editor" [innerHTML]="trustedHtml"></div>
</div>
